import { navigateOrOpenNewTab } from "../lib/dashboardNav.js";
import type { TabId } from "../types.js";

const TABS: Array<{ id: TabId; icon: string; label: string }> = [
  { id: "overview", icon: "🎯", label: "Overview" },
  { id: "health", icon: "🌡️", label: "How are the tables?" },
  { id: "acquisition", icon: "👀", label: "Are people playing?" },
  { id: "engagement", icon: "🎮", label: "Games" },
  { id: "retention", icon: "💵", label: "Retention" },
  { id: "sessions", icon: "💬", label: "Interaction sessions" },
  { id: "presence", icon: "📡", label: "Presence" },
  { id: "events", icon: "📋", label: "Raw Event Explorer" },
];

interface TabNavProps {
  activeTab: TabId;
  /** Shareable href for each tab (preserves filters / explorer state when switching tabs). */
  tabHref: (tab: TabId) => string;
  onTabChange: (tab: TabId) => void;
}

export function TabNav({ activeTab, tabHref, onTabChange }: TabNavProps) {
  return (
    <div className="no-print mb-3 flex gap-2 overflow-x-auto rounded-xl border border-border bg-panel p-2">
      {TABS.map((t) => {
        const href = tabHref(t.id);
        const active = activeTab === t.id;
        const title = `${t.icon} ${t.label}`;
        return (
          <a
            key={t.id}
            href={href}
            className={`rounded-lg border px-3 py-2 text-sm font-semibold whitespace-nowrap no-underline ${
              active
                ? "border-[#4f80c7] bg-[#1f3151] text-white"
                : "border-border-subtle bg-[#15233b] text-text-secondary hover:bg-[#1a2d4d]"
            }`}
            title={
              active
                ? title
                : `${title} — click: this tab · middle-click / Ctrl/Cmd+click: new tab`
            }
            onClick={(e) => {
              if (e.button !== 0) return;
              if (navigateOrOpenNewTab(href, e) === "new") {
                e.preventDefault();
                return;
              }
              e.preventDefault();
              onTabChange(t.id);
            }}
            onAuxClick={(e) => {
              if (e.button !== 1) return;
              e.preventDefault();
              window.open(href, "_blank", "noopener");
            }}
          >
            <span className="mr-1.5" aria-hidden>
              {t.icon}
            </span>
            {t.label}
          </a>
        );
      })}
    </div>
  );
}
